export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'

export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION'

export const API_CALL = 'API_CALL'
